import { useEffect, useRef } from 'react';
import { useStore } from '../store';
import { PayloadLibrary } from './PayloadLibrary';

// Topbar drawer holding the payload library. Same shell as the Shares drawer.
export function PayloadsMenu() {
  const open = useStore((s) => s.payloadsOpen);
  const setOpen = useStore((s) => s.setPayloadsOpen);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      const wrap = ref.current?.parentElement ?? ref.current;
      if (wrap && !wrap.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open, setOpen]);

  if (!open) return null;
  return (
    <div className="shares-menu shares-drawer payloads-drawer" ref={ref} role="dialog" aria-label="Payload library">
      <div className="shares-head">
        <span>Payloads</span>
        <button type="button" className="shares-close" onClick={() => setOpen(false)} aria-label="Close" title="Close (Esc)">×</button>
      </div>
      <PayloadLibrary onApplied={() => setOpen(false)} />
    </div>
  );
}
